<template>
	<div class="card-v2">
		<LoginForm @login="onLogin" :loading="isRedirecting" />
		<p class="fs-12 lh-14 fw-500 mt-12">Don't have an account yet? <router-link :to="{ name: $routes.Onboarding.name }">Join ShootWith.Me</router-link></p>
	</div>
</template>

<script>
import LoginForm from '@/components/forms/LoginForm';

export default {
	name: 'Login',
	components: {
		LoginForm
	},
	data() {
		return {
			isRedirecting: false,
		};
	},
	computed: {
		postLoginRoute: {
			get() {
				return this.$store.getters['auth/postLoginRoute'];
			},
			set(route) {
				this.$store.commit('auth/setPostLoginRoute', route);
			},
		},
	},
	methods: {
		async onLogin() {
			if (this.isRedirecting) {
				return;
			}
			this.isRedirecting = true;
			const store = this.$store;
			try {
				let event = store.getters['onboarding/event'];
				if (event) {
					let eventId = event.id;
					if (!eventId) {
						event = await store.dispatch('events/createEvent', event);
						eventId = event.id;
					}
					this.postLoginRoute = {
						name: this.$routes.FindHelpSearch.name,
						params: {
							eventId
						}
					};
					store.commit('events/setSearchEvent', event);
					store.commit('events/setSearchQueue', null);
					store.commit(
						'events/setSearchHiringUserProfile',
						store.getters['onboarding/hiringUserProfile']
					);
					store.commit('onboarding/clear');
					store.commit('onboarding/setHiringUserProfile', null);
				}

				await this.$router.push(this.postLoginRoute || {
					name: this.$routes.Dashboard.name
				});
			} finally {
				this.isRedirecting = false;
			}
		},
	},
	beforeDestroy() {
		this.postLoginRoute = null;
	},
	metaInfo: {
		title: 'Login',
	},
};
</script>